<dashboard-dialog-frame class="engagement-interaction-form-dialog" [header]="headerTitle()" [dialogRef]="dialogRef">
	<div class="d-flex flex-column justify-content-between gap-3 p-3 h-100">

		<div class="d-flex flex-column gap-3">
			<common-date-time-field [field]="contactedDate()"></common-date-time-field>
			@if(showStaffSelector()){
			<staff-selector-widget [disabled]="!isEnabledForm()" [data]="staffData()" [userId]="staffUserId()"
				[value]="{staffId: values().staffId}" (valueChange)="handleStaffValueChange($event)"></staff-selector-widget>
			}

			<common-select-field [field]="contactMethod()"></common-select-field>
			<common-text-field [field]="note()"></common-text-field>
		</div>

		<div>
			<common-button-row [center]="true">
				<button #interactionSaveBtn class="btn btn-standard">
					{{dialogContext.data?.mode === dialogMode.EDIT ? 'Update' : 'Save'}}
				</button>
				<button class="btn btn-standard" (click)="closeDialog()">Cancel</button>
			</common-button-row>
		</div>
	</div>
</dashboard-dialog-frame>